module.exports = __webpack_public_path__ + "media/effects-18.ba42e902.webm";